import { useConnectModal } from '@rainbow-me/rainbowkit';

import Button from '~/components/common/Button';
import { useConnectedWallet } from '~/contextProviders/ConnectedWallerProvider';
import { useGameAuthentication } from '~/contextProviders/GameAuthenticationProvider';

// connect account OR generate access token
export default function VerifyWarriorsWallet({ message }: {message?: string}) {
  const { account } = useConnectedWallet();
  const { generateAccessToken, isLoadingAccessToken } = useGameAuthentication();
  const { openConnectModal } = useConnectModal();

  if (account?.connected) {
    return (
      <Button
        className="warrior__attack__confirm__button primary"
        label={
          isLoadingAccessToken ?
            'Confirm in your wallet' : message ? message : 'Verify your Warriors'
        }
        onClick={generateAccessToken}
        disabled={isLoadingAccessToken ? true : false}
      />
    );
  }
  return (
    <>
      <Button
        className="warrior__attack__confirm__button primary"
        label="Connect your wallet"
        onClick={openConnectModal}
      />
    </>
  );
}
